export const MERCHANT_DOMAIN = process.env.REACT_APP_MERCHANT_DOMAIN || 'http://localhost:4001'
export const IMAGE_DOMAIN = process.env.REACT_APP_IMAGE_DOMAIN || 'http://localhost:5001'


// WEBPACK FOOTER //
// ./src/config.js